<template>
  <sh-modal
    label="Recommendation"
    id="rejected-modal"
    modal-height="fit-content"
    modal-width="600px"
    @modal-closed="closeModal"
  >
    <div slot="header" style="display: flex; width: 100%">
      <div>
        <sh-text size="header-1">Recommendation</sh-text>
      </div>
    </div>
    <sh-text style="text-align: left; font-weight: bold"
      >Status: {{ getReviewDescription(status) }}
    </sh-text>
    <sh-text style="text-align: left">{{ description }} </sh-text>
    <sh-text style="text-align: left">Summary: {{ summary }} </sh-text>

    <!-- <sh-divider spacing="l"></sh-divider> -->

    <div
      style="
        display: flex;
        text-align: left;
        margin-top: 24px;
        margin-bottom: 24px;
      "
    >
      <div>
        <sh-text>Recommendation rating:</sh-text>
      </div>

      <div style="width: 100px; margin-left: 24px">
        <star-rating
          v-model:rating="rating"
          :read-only="true"
          :star-size="25"
          :show-rating="false"
          @rating-selected="setRating($event)"
        >
        </star-rating>
      </div>
    </div>
    <sh-input-text
      style="margin-bottom: 24px"
      :value="feedback"
      readonly="true"
      label="Recommandation comment added by user:"
    ></sh-input-text>
    <div class="buttonsFooter">
      <sh-button
        size="m"
        label="Reset"
        @click="resetSelectedRecommend"
      ></sh-button>
    </div>
  </sh-modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import StarRating from "vue-star-rating";
import axios from "axios";

export default {
  name: "RecommendationRejected",
  props: {
    selecteddivision: {
      type: String,
      required: true,
    },
  },
  // Other component options go here
  components: {
    StarRating,
  },
  data() {
    return {
      rating: null,
      feedback: "",
      description: "",
      status: "",
      summary: "",
      uid: "",
    };
  },
  computed: {
    ...mapGetters([
      "selectedRecommandationIndex",
      "filteredRecommend",
      "getReviewDescription",
      "backendURL",
      "selectedCountry",
    ]),
    ...mapGetters("oidcStore", ["oidcUser"]),
  },
  methods: {
    ...mapActions(["pushNotification", "updateRecommendations"]),
    ...mapMutations(["setEditRecInProgress"]),
    closeModal() {
      document.querySelector("#rejected-modal").visible = false;
      this.setSelectedRecommendation(this.selectedRecommandationIndex);
    },
    setSelectedRecommendation(indexOfSelected) {
      if (indexOfSelected === undefined) {
        this.rating = null;
        this.feedback = "";
        this.description = "";
        this.status = "";
        this.summary = "";
        this.uid = "";
      } else {
        this.rating = this.filteredRecommend[indexOfSelected].rating;
        this.feedback = this.filteredRecommend[indexOfSelected].feedback;
        this.description = this.filteredRecommend[indexOfSelected].description;
        this.status = this.filteredRecommend[indexOfSelected].status;
        this.summary = this.filteredRecommend[indexOfSelected].summary;
        this.uid = this.filteredRecommend[indexOfSelected].uid;
      }
    },
    getCurrentDate() {
      var m = new Date();
      var dateString =
        m.getUTCFullYear() +
        "/" +
        ("0" + (m.getUTCMonth() + 1)).slice(-2) +
        "/" +
        ("0" + m.getUTCDate()).slice(-2) +
        " " +
        ("0" + m.getUTCHours()).slice(-2) +
        ":" +
        ("0" + m.getUTCMinutes()).slice(-2) +
        ":" +
        ("0" + m.getUTCSeconds()).slice(-2);
      return dateString;
    },

    resetSelectedRecommend() {
      document.querySelector("#rejected-modal").visible = false;
      this.resetRejectedRecommendation(this.$route.params.area);
    },
    updateSelectedRecomendation(updates) {
      //todo check this
      if (this.uid) {
        let index = updates.findIndex((upd) => upd.uid === this.uid);

        if (index !== -1) {
          this.feedback = updates[index].feedback;
          this.status = updates[index].status;
          // this.additional_comment = updates[index].detailed_reason; // todo check this
          this.rating = updates[index].rating;
          // this.comment = updates[index].reason_for_change; // todo check this
          // this.time = updates[index].time;

          // console.log(Object.keys(updates[index]));
        }
      }
    },
    async resetRejectedRecommendation(area) {
      this.setEditRecInProgress(true);
      let reqStr = "";
      if (this.selecteddivision == "ImagingZone") {
        reqStr =
          this.backendURL +
          "/api/service_zone_current_data/recommendation_feedback_new/" +
          this.selectedCountry.iso_3166_1 +
          "/" +
          area;
      } else {
        reqStr =
          this.backendURL +
          "/api/service_current_data/recommendation_feedback_new/" +
          this.selectedCountry.iso_3166_1 +
          "/" +
          area;
      }
      let payload = {
        uid: this.uid,
        status: this.status,
        action: "reset",
        username: this.oidcUser ? this.oidcUser.email : "",
        time: this.getCurrentDate(),
        // todo check if new_assignments is needed
      };
      console.log(area, payload);
      try {
        const res = await axios.post(reqStr, payload);
        // console.log("******************************** dgrade opts ", res.data);
        this.updateRecommendations(res.data);

        this.updateSelectedRecomendation(res.data); // todo check this
        this.setEditRecInProgress(false);
      } catch (err) {
        console.log(err);
        this.setEditRecInProgress(false);
        this.pushNotification({
          type: "error",
          label: "Reset Recommendations error",
          text: "Recommendation could not be reset",
        });
      }
    },
  },
  watch: {
    selectedRecommandationIndex: function (val) {
      this.setSelectedRecommendation(val);
    },
  },
};
</script>

<style scoped>
.buttonsFooter {
  float: right;
}
</style>
